module.exports = __webpack_public_path__ + "img/Stories.51f94f3f.jpg";